module.exports = __webpack_public_path__ + "static/2-1200-8c929d752611a55515a76e69b46b5550.png";